import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';

import SidePanelPlaceholder from './components/SidePanelPlaceholder';
import MainPlaceholder from './components/MainPlaceholder';

function DetailedCarPlaceholder() {
  return (
    <Component>
      <MainPlaceholder />
      <StyledSidePanelPlaceholder />
    </Component>
  );
}

export default DetailedCarPlaceholder;

const Component = styled.div`
  max-width: 1600px;
  width: 100%;
  margin: 0 auto;
  display: flex;
`;

const StyledSidePanelPlaceholder = styled(SidePanelPlaceholder)`
  ${media.tablet(css`
    display: none;
  `)}
`;
